import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getProceedingProofsByOwnerOptions } from '@/module/Author/Proceeding/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface ProceedingOwnerProofListProps {
  proceedingId: Id;
  userId: Id;
}

export function ProceedingOwnerProofList({ proceedingId, userId }: ProceedingOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getProceedingProofsByOwnerOptions(proceedingId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="proceeding"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
